import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bstable',
	templateUrl:'./BSTablePage.html',
	styles: [],
	styleUrls:['./BSTablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSTablePage
{
	mdContent_164 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.tables.BSTable;
\`\`\``;
	mdContent_165 = `\`\`\`java
new BSTable<>()
\`\`\``;
	mdContent_166 = `\`\`\`java
var table = new BSTable<>();
table.setStriped(true);
table.setBordered(true);
table.setHover(true);
table.setResponsive(true);
\`\`\``;
}
